import React, { useContext, useEffect, useState } from "react";
import { DContext } from "../../context/Datacontext";
import { PaginationMode } from "../../hooks/PaginationMode";


export default function JobPagination({ setAllJobs, setRequirement, mode, setPaginationData }) {
    const { BeURL, showAlert } = useContext(DContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPage, setTotalPage] = useState(0);
    const [total, setTotal] = useState(0);
    const [perPageTotal,setPerPageTotal]=useState(0)

    useEffect(() => {
        PaginationMode({
            mode,
            currentPage,
            rowsPerPage,
            perPageTotal,
            setAllJobs,
            setRequirement,
            setPaginationData,
            setRowsPerPage,
            setCurrentPage,
            setTotal,
            setTotalPage,
            setPerPageTotal,
            total,
            BeURL,
            showAlert
        });
    }, [mode, currentPage, rowsPerPage]);

    const handlePagination = (dir) => {
        if (dir === "prev" && currentPage > 1) setCurrentPage((p) => p - 1);
        if (dir === "next" && currentPage < totalPage) setCurrentPage((p) => p + 1);
    };
    
    return (
        <div className="mt-4 flex items-center justify-between px-10">
            <div className="flex items-center gap-2 mb-2">
                <label htmlFor="recordsPerPage" className="text-sm">
                    Records per page :
                </label>
                <select
                    id="recordsPerPage"
                    value={rowsPerPage}
                    onChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
                    className="ml-2 px-3 py-1 border rounded"
                >
                    {[10, 20, 25, 50, 75, 100].map((n) => (
                        <option key={n} value={n}>
                            {n}
                        </option>
                    ))}
                </select>
            </div>

            <div className="flex justify-center items-center gap-4">
                <span
                    className={`material-symbols-outlined text-3xl ${currentPage === 1
                            ? "cursor-not-allowed text-gray-400"
                            : "cursor-pointer text-primary-500"
                        }`}
                    onClick={() => handlePagination("prev")}
                >
                    chevron_left
                </span>
                <span>{currentPage} of {totalPage}</span>
                <span
                    className={`material-symbols-outlined text-3xl ${currentPage === totalPage
                            ? "cursor-not-allowed text-gray-400"
                            : "cursor-pointer text-primary-500"
                        }`}
                    onClick={() => handlePagination("next")}
                >
                    chevron_right
                </span>
            </div>

            <div>
                {mode === "job" ?
(                    <span className="mr-4 text-gray-700 items-center">
                        Total Jobs : {total}
                    </span> )
                 :  (
                    <span className="mr-4 text-gray-700 items-center">   
                        Total : {perPageTotal}  / {total}
                    </span>
                )}
            </div>

        </div>
    );
}
